import React from 'react';
import { Box, Skeleton } from '@landr/maestro';

export const ShareModalSkeleton: React.FC = (): JSX.Element => {
    return (
        <>
            <Box display="flex" flexDirection="column" mb="md">
                <Skeleton height="18px" width="100%" mb="xs" />
                <Skeleton height="18px" width="25%" />
            </Box>
            <Skeleton height="md" width="100%" />
        </>
    );
};
